<!--天津德源svg图点击弹出曲线-->
<template>
  <div class="virtualDeviceRTCurveBody">
    <!--日期弹窗-->
    <div class="pageBody" slot="body">
      <div v-show="false">{{nowDeviceName}}</div>
      <div style="display: flex;align-items: center;justify-content: space-between;padding:0px 10px">
        <div class="buttonLine" style="width:50%">

          <!-- <iconButton @buttonClick='downloadExcel' buttonText='导出' icoName="wedoButton/download.png"></iconButton> -->
        </div>
        <el-radio-group v-model="tabPosition">
          <el-radio-button label="top">折线</el-radio-button>
          <el-radio-button label="left">柱状</el-radio-button>
        </el-radio-group>
      </div>
      <!--图表-->
      <vchart ref='vchart' style="height: 400px" v-show="tabPosition == 'top'"></vchart>
      <vchart ref='vchart2' style="height: 400px" v-show="tabPosition == 'left'"></vchart>

    </div>
  </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart,
    },
    props: {



    },
    data () {
      return {
        tabPosition: 'left',
        apptypeValue: [],
        nowIndex: 0,
        from2name: {},
        nowApptypeGroups: [],
        nowSeries: [],
        refreshInterval: 2000,
        columns: [{
          name: '设备名称',
          key: 'devicename'
        },{
          name: '变量名称',
          key: 'variablename'
        },{
          name: '实时值',
          key: 'value'
        }],
        options: {
          title: {
            text: "",
            left: 'center',
            textStyle: {
              fontWeight: 800,
              fontSize: 22,
            }
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            top: '-5',
            right: "50",
            feature: {
              magicType: {
                type: ['stack','tiled'],title: {
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },
              saveAsImage: {
                show: true,
                title: '下载图片'
              },

            },

          },
          tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: (params,ticket,callback) => {
              var label=new Date(params[0].data[0]).formatByTime()+"</br>"
              params.forEach(item => {
                var values;
                if(isnull(item.data[1])) {
                  values="无采集数据";
                } else {
                  values=cutDigital(item.data[1]);
                }
                label+=item.seriesName+" : "+values+"</br>"
              })
              return label;
            },
            axisPointer: {
              animation: false
            }
          },
          xAxis: {
            type: 'time',
            splitLine: {
              show: true
            }
          },
          yAxis: {
            type: 'value',
            max: value => {
              return Math.ceil(value.max)|0+10
            },
            boundaryGap: [0,'100%'],
            splitLine: {
              show: true
            }
          },
          grid: {
            left: '5%',
            right: '5%',
            bottom: '70'
          },
          legend: {
            data: [],
            type: 'scroll',
            bottom: '20px',
            right: 30,
            formatter: function(name) {
              return echarts.format.truncateText(name,100,'14px Microsoft Yahei','…');
            },
            tooltip: {
              show: true
            },
            selected: {}
          },
          series: []
        },
        optionsBar: {
          title: {
            text: "",
            left: 'center',
            textStyle: {
              fontWeight: 800,
              fontSize: 22,
            }
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            top: '-5',
            right: "50",
            feature: {
              magicType: {
                type: ['stack','tiled'],title: {
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },
              saveAsImage: {
                show: true,
                title: '下载图片'
              },

            },

          },
          tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: (params,ticket,callback) => {
              var label=new Date(params[0].data[0]).formatByTime()+"</br>"
              params.forEach(item => {
                var values;
                if(isnull(item.data[1])) {
                  values="无采集数据";
                } else {
                  values=cutDigital(item.data[1]);
                }
                label+=item.seriesName+" : "+values+"</br>"
              })
              return label;
            },
            axisPointer: {
              animation: false
            }
          },
          xAxis: {
            type: 'time',
            splitLine: {
              show: true
            }
          },
          yAxis: {
            type: 'value',
            max: value => {
              return Math.ceil(value.max)|0+10
            },
            boundaryGap: [0,'100%'],
            splitLine: {
              show: true
            }
          },
          grid: {
            left: '5%',
            right: '5%',
            bottom: '70'
          },
          legend: {
            data: [],
            type: 'scroll',
            bottom: '20px',
            right: 30,
            formatter: function(name) {
              return echarts.format.truncateText(name,100,'14px Microsoft Yahei','…');
            },
            tooltip: {
              show: true
            },
            selected: {}
          },
          series: []
        },
        destroyedList: [],
        variableNameList: []
      }
    },
    created () {
      setTimeout(() => {
        this.apptypeValue=['全选'];
        this.selectAll();
      },1000)
    },
    mounted () {
      debugPage=this
      this.$refs.vchart.setData(this.options,true)
      this.$refs.vchart2.setData(this.options,true)
      addNewTask('refreshRealPowerQuality',1000,this.refreshInterval,-1,() => {
        this.addData()
      })
      this.apptypeValue=this.nowSelectAppTypeGroupIds
    },
    destroyed () {
      removeTask('refreshRealPowerQuality')
      this.realTimeValueStore.commit("removeKeys",this.destroyedList)
    },
    computed: {
      nowVirtualDeviceList () {
        return this.$store.deviceStore.state.nowVirtualDeviceList
      },
      //当前设备名称
      nowDeviceName () {
        this.variableNameList=[this.$store.deviceStore.state.deviceName]
        return this.$store.deviceStore.state.deviceName
      },
      nowSelectAppTypeGroupIds () {
        return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
      },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      variableStore () {
        return this.$store.variableStore
      },
      archivesStore () {
        return this.$store.archivesStore
      },
      deviceStore () {
        return this.$store.deviceStore
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      variableTree () {
        var tree=this.virtualDeviceList
        var arr=[]
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.hasOwnProperty('children')&&row.children.length!=0) {
                getStr(row.children)
              } else {
                if(row.type=="virtualDevice") {
                  arr.push(row)
                }

              }
            })
          }
          getStr(tree)
        }
        recursiveFunction()
        //根据当前设备名称找出树形结构相对应的设备对象
        var nowDevice=arr.filter(item => item.label==this.nowDeviceName)
        this.destroyedList=nowDevice
        // this.$store.deviceStore.commit('saveDeviceObj',nowDevice)

        if(nowDevice==undefined||isempty(nowDevice)) {

          return []
        }
        var variableTreeArr=[]
        nowDevice.forEach(item => {
          var variableTree=[]
          if(item.type=="virtualDevice") {
            variableTree=this.variableStore.getters.getVariableTree(item.no)
          }
          variableTree.forEach(tree => {
            tree.devicename=item.name
          })
          variableTreeArr.push(variableTree)
        })
        var result=[]
        variableTreeArr.forEach(item => {
          result=result.concat(item)
        })

        return result
      },
      apptypeGroups () {
        //所有已选中的设备所具有的变量类型组
        var list=[]
        var apptypeGroupIds=[]
        this.variableTree.forEach(apptypeGroup => {
          if(!apptypeGroupIds.includes(apptypeGroup.id)) {
            apptypeGroupIds.push(apptypeGroup.id)
            list.push(apptypeGroup)
          }
        })
        //排序
        return list.sort((a,b) => {
          return a.serialnum-b.serialnum
        })
      },

      nowVariableList () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            i.devicename=item.devicename
            v2.push(i)
          })
        })
        v2.sort((a,b) => {
          return a.typeNo-b.typeNo
        })

        return v2
      },
      pageLen () {
        return this.dataList.length<20? this.dataList.length:20
      },
      nowPage () {
        // 按照页码来返回当前应该显示的列表
        var list=this.dataList.filter((item,index) => {
          return index>=this.nowIndex*this.pageLen&&index<(this.nowIndex+1)*this.pageLen
        })
        return list
      },
      dataList () {
        //获取值
        var vl=this.realTimeValueStore.getters.getValue(this.variableNameList)
        return this.variableNameList.map((item,index) => {
          var value=this.realTimeValueStore.getters.getText(item,vl[index])
          if(isNaN(parseFloat((value)))||isnull(parseFloat((value)))) {
            value='- -'
          }
          var name=this.from2name[item]? this.from2name[item]:item
          let deviceName=''
          this.nowVariableList.forEach(item2 => {
            if(item2.fromName==item) {
              deviceName=item2.fromName.split('.')[0]
            }
          })
          return {
            devicename: deviceName,
            variablename: name.subByFirstChar("."),
            value,
          }
        })

      }
    },
    watch: {
      variableNameList (nv,ov) {
        // console.log("实时曲线nv",nv);
        // console.log("实时曲线ov",ov);
        this.realTimeValueStore.commit("removeKeys",ov)
        this.realTimeValueStore.commit("addKeys",nv)
        //重置缓存数据
        var list=[]
        var newLits=[]
        var dataList=[]
        var now=new Date().getTime()
        for(var i=0;i<20;i++) {
          dataList.unshift([now-this.refreshInterval*i,undefined])
        }
        nv.forEach((item,index) => {
          let deviceName=''
          this.nowVariableList.forEach(item2 => {
            if(item2.fromName==item) {
              deviceName=item2.fromName.split('.')[0]
            }
          })
          var name=deviceName+"_"+item.subByFirstChar('.')
          list.push({
            name,
            fromName: item,
            type: 'line',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            symbol: 'emptyCircle',
            data: dataList.copy()
          })
          newLits.push({
            name,
            fromName: item,
            type: 'bar',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            symbol: 'emptyCircle',
            data: dataList.copy()
          })
        })
        this.nowSeries=list
        this.options.series=list
        var selected={}
        this.options.legend.data=
          nv.map((item,index) => {
            let deviceName=''
            this.nowVariableList.forEach(item2 => {
              if(item2.fromName==item) {
                deviceName=item2.fromName.split('.')[0]
              }
            })
            var name=deviceName+"_"+item.substr(item.indexOf('.')+1)
            if(index>5) {
              selected[name]=false
            }
            return {
              name: name,
              icon: 'roundRect'
            }
          })
        this.options.legend.selected=selected
        var columnar=JSON.parse(JSON.stringify(this.options))
        columnar.series=newLits
        this.$refs.vchart.setData(this.options,true)
        this.$refs.vchart2.setData(columnar,true)
      },
      apptypeValue (nv,ov) {
        this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',nv)
        let list=[]
        if(!isempty(nv)) {
          nv.forEach(item => {
            this.apptypeGroups.forEach(item2 => {
              if(item==item2.id) {
                list.push(item2)
              }
            })
          })
        }
        this.nowApptypeGroups=list
      },

    },
    methods: {
      downloadExcel () {
        let title='<thead><tr>'
        title+='<th colspan=6>'+new Date().formatByTime('-')+' 实时值'+'</th>'
        title+='</tr></thead>'
        let aa=document.getElementsByTagName('thead')[0];//头部表达
        let bb=document.getElementsByTagName('tbody')[0];//列表内容
        let table=title+aa.innerHTML+bb.innerHTML
        exportToExcel(table,"实时值报告")
      },
      selectAll () {
        //全选 先判断是否有选中的，有选中就清空
        if(this.apptypeValue.length==1) {
          this.nowApptypeGroup=this.apptypeGroups
          let idList=[]
          this.apptypeGroups.forEach(item => {
            idList.push(item.id)
          })
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',idList)
          this.apptypeValue=idList
        } else {
          this.nowApptypeGroup=[]
          this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds',[])
          this.apptypeValue=[]
        }
      },
      addData () {
        //获取值
        if(this.$refs.vchart==undefined) {
          return
        }
        var vl=this.realTimeValueStore.getters.getValue(this.variableNameList)
        var now=new Date().getTime()
        this.nowSeries.forEach((item,index) => {
          item.data.shift()
          var temp=vl[index]
          if(isNaN(parseFloat((temp)))||isnull(parseFloat((temp)))) {
            temp=undefined
          }
          item.data.push([now,temp])
        })
        this.$refs.vchart.setData({
          series: this.nowSeries
        })
        var columnar=JSON.parse(JSON.stringify(this.nowSeries))
        columnar.forEach(item => item.type='bar')
        this.$refs.vchart2.setData({
          series: columnar
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  /deep/.el-radio-button__inner {
    padding: 7px 15px;
  }

  .pageBody {
    width: 100%;
    height: 100%;
    /* padding-bottom: 60px; */
    /* padding-top: 75px; */
  }

  .el_Tree_Body {
    padding: 0 !important;
    height: 94.5%;
    border-top: 0;
    border-bottom: 0;
  }

  /deep/.el-tree {
    width: 2.65rem !important;
    min-width: 2.55rem !important;
  }

  .virtualDeviceRTCurveBody {
    width: 100%;
    display: flex !important;
    /* align-items: center; */
    justify-content: space-between;
    background-color: white;
  }
</style>